import type { User } from "types/User";

const checkRights = (
  currentUser: any,
  rightKey: string,
  siteIds: number[] = [],
  jokers: string[] = [],
  needsSites = false
) => {
  if (
    ["isSuperadmin", ...jokers].find((jr: string) => currentUser[jr] === true)
  ) {
    return true;
  }

  if (needsSites && siteIds === undefined) {
    return false;
  }

  return !!siteIds.find((siteId: number) =>
    currentUser?.checkMyRight(siteId, rightKey, jokers)
  );
};

/**
 * Vérifie si un utilisateur possède tous les droits spécifiés pour une organisation donnée
 * @param user - L'utilisateur à vérifier
 * @returns true si l'utilisateur a tous les droits demandés, false sinon
 */
export const hasUserRights = (user: User | null | undefined): boolean => {
  // Si superadmin, toujours true
  if (user?.isSuperadmin) {
    return true;
  }
  return true;
};

export default checkRights;
